<template>
  <div class="content">
       <!-- <div id="top">
      
   <header-box title='成绩证书'></header-box>    
   
    </div> -->
    <!-- <div id="top">
      <span class="rightcha"
        ><img width="20px" src="../../assets/cha.png" />
        <span class="centerwz">成绩证书</span></span
      >
    </div> -->
<div class="boxpad">
 <div class="flexcontain">
    <div class="own_name">考生信息&nbsp;: &nbsp;</div>
 <input-box  class="own_input" v-model="ownnameinput" @bluript='searchblur' placeholder="可搜索姓名或手机号">
    </input-box>
 </div>

         <!-- <div class="flexcontain" @click="select1click">
             <span class="own_name">科目：</span>
            <choose-box class="compomnet " :rtest='choosetype1'></choose-box>
 
</div> -->
         <div class="flexcontain" @click="select2click">
             <span class="own_name">考试日期：</span>
            <choose-box class="compomnet " :rtest='choosetype2'></choose-box>
 
</div>
          <!-- <div class="flexcontain" @click="select3click">
             <span class="own_name">预约时间：</span>
            <choose-box class="compomnet " :rtest='choosetype3'></choose-box>
 
</div> -->

         <div class="flexcontain" @click="select4click">
             <span class="own_name">证书状态：</span>
            <choose-box class="compomnet " :rtest='choosetype4'></choose-box>
 
</div>

 <table v-if="examarr.length>0" class="tablecontain">
    <thead>
        <tr class="tablehead">
            <th>姓名</th>
            <th>手机号</th>
            <th class="grade">理论成绩</th>
			      <th class="grade">实操成绩</th>
			      <th class="grade">考试日期</th>
            <th class="grade">证书状态</th>
        </tr>
    </thead>
    <!-- <tbody>
        <tr class="tablebody" v-for="(item ,index) in examarr" :key="index" >
            <td>{{item.userName}}</td>
            <td>{{item.mobilePhone}}</td>
            <td v-if="item.subjectScore">{{item.subjectScore['实操']}}</td>
            <td v-if="item.subjectScore"> {{item.subjectScore['理论']}}</td>
            <td>{{item.createTime}}</td>
            <td v-if="item.certificateStatus=='pending'" colspan="3">待生成</td>
            <td v-if="item.certificateStatus==''" colspan="3">不合格</td>
            <td v-if="item.certificateStatus=='finish'" colspan="3">已生成</td>
        </tr>
    </tbody> -->
</table>
<div style="text-align:center;margin-top:10px;color:grey">暂无数据</div>
</div>
<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="Place1Show"
			>
 <van-picker
  title="标题"
  show-toolbar
  :columns="columnz1"
  @confirm="zConfirm1"
  @cancel="zCancel1"
  @change="zChange1"
/>
	</van-popup>
	<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="Place2Show"
			>
 <van-datetime-picker
  v-model="currentDate"
  type="date"
  confirm-button-text="完成"
  cancel-button-text="考试时间"
  :min-date="minDate"
  :max-date="maxDate"
  @confirm="zConfirm2"
  @cancel="zCancel2"
  @change="zChange2"
  :formatter="formatter"
/>
	</van-popup>

<van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="Place3Show"
			>
 <van-picker
  title="标题"
  show-toolbar
 :columns="columnz3"
 @confirm="zConfirm3"
  @cancel="zCancel3"
  @change="zChange3"
/>
	</van-popup>

    <van-popup
			  position="bottom"
			  round
			  :style="{ height: '50%' }"
			  v-model="Place4Show"
			>
 <van-picker
  confirm-button-text="完成"
  cancel-button-text="证书状态"
  show-toolbar
 :columns="columnz4"
 @confirm="zConfirm4"
  @cancel="zCancel4"
  @change="zChange4"
/>
	</van-popup>
	 
   
  </div>
</template>

<script>
import inputBox from '@/components/input.vue'
import datetime from '../../utils/datetime.js'
import Select from '@/components/Select'
import chooseBox from '@/components/choose'
import headerBox from '@/components/header.vue'
import {achievementp,findExamAchievement}  from  '../../api/apitotal.js'
export default {
  data() {
    return {
             examarr: [{
          name: '王小虎',
          examSubiectName: '2',
		  examDate:'10-03-21',
		  appointmentTime:'10:30-11:00',
		  phone:'14235243534', 
		  ExamDynamic: '2',
        }, {
          name: '张三',
          examSubiectName: '1',
		  phone:'15564213545',
		  examDate:'10-11-02',
		  appointmentTime:'9:30-10:00',
		  ExamDynamic: '2',
        } ],
Place1Show:false,
Place2Show:false,
Place3Show:false,
Place4Show:false,
 columnz4: ['全部','不合格', '待生成', '已生成'],
 columnz3: ['养老护理专业', '计算机专业'],
 columnz2: ['中专', '大专', '本科', '硕士', '博士'],
 columnz1: ['养老护理专业', '计算机专业'],
 ownnameinput:'',
 choosetype1:'可选择考试科目',
 choosetype2:'可选择日期',
 choosetype3:'可选择时间范围',
 choosetype4:'全部',
 chooseindex1:null,
 chooseindex2:null,
 chooseindex3:null,
 chooseindex4:null,
   minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
    };
  },
  components: {
    headerBox,
    Select,
    chooseBox,
    inputBox
  },
  created(){
this.initdatatable()
  },
  methods: {
       //添加年月日字
   formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } 
      return value
    },
        searchblur(){
  this.searconfirm()
    },
        searconfirm(){
var datime=null
          // achievement/findExamAchievement﻿?keyword=null&certificateStatus=2&examDate=null﻿

     if(this.choosetype2=='可选择日期'){

     }
      var inputdata=`keyword=${this.ownnameinput.length>0?this.ownnameinput:null}&certificateStatus=${typeof(this.chooseindex4)=='number'?this.chooseindex4+1:null}&examDate=${null}`
 
            findExamAchievement(`achievement/findExamAchievement`,inputdata,'post').then(res=>{
          console.log(res)
          if(res.data.success&&res.status==200){
       this.examarr=res.data.data.data
       }
    })
    },
     initdatatable(){
      var fenye=`page=1&limit=10`
         achievementp(`achievement/findAll`,fenye,'post').then(res=>{
         console.log(res)
       if(res.data.success&&res.status==200){
        this.examarr=res.data.data.list
        // localStorage.setItem('ID',res.data.data.id)
       }
     
    })
 },
 select1click(){
this.Place1Show=true
 },

  select2click(){
this.Place2Show=true
 },
  select3click(){
this.Place3Show=true
 },
  select4click(){
this.Place4Show=true
 },
  zConfirm1(value, index){
   this.zCancel1() 
   this.choosetype1=value
   this.chooseindex1=index
 },
   zConfirm2(value, index){
    this.zCancel2() 
     this.choosetype2=datetime(value) 
      this.searconfirm()
  
 },
   zConfirm3(value, index){
    this.zCancel3() 
        this.choosetype3=value
   this.chooseindex3=index
    //  this.choosetype3=datetime(value)
//    this.chooseindex3=index 
 },
   zConfirm4(value, index){
    this.zCancel4() 
     this.choosetype4=value
   this.chooseindex4=index 
    this.searconfirm()
 },
  zCancel1(){
  this.Place1Show=false  
 },
   zCancel2(){
  this.Place2Show=false  
 },
   zCancel3(){
  this.Place3Show=false  
 },
   zCancel4(){
  this.Place4Show=false  
 },
    
 zChange4(picker, value, index){

 },
  zChange1(picker, value, index){

 },
  zChange2(picker, value, index){

 },
  zChange3(picker, value, index){

 },
  },
};
</script>

<style scoped lang="less">
.boxpad{
    padding: 0 @checkringht @checkringht @checkringht;
    background: @whitee;
}
#top {
  text-align: center;
 height: @headerh;
 box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  /* padding-top: 60px;
  margin-left: 400px; */
  min-width: 1080px;
  height: 100vh;
  background-color: white;
}
.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
.flexcontain{
    margin-top: @checkringht;
     display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
     .own_name{
      color: @leftcolor;
      font-weight: 600;
    }
}
.own_input,.cat-choose{
    flex: 1;
    height: @minboxgao;
    line-height: @minboxgao;
}
.tablecontain{
  width: 100%;
   border-left: 1px solid @tableborder;
  border-top: 1px solid @tableborder;
  border-spacing: 0;
  margin-top: @minboxgao;
    .tablebody:nth-child(2n+2){
      background: @tablecolor;
  }
 
 }
 .tablehead>th,.tablebody>td{
  border-right: 1px solid @tableborder;
  border-bottom: 1px solid @tableborder;
  text-align: center;
 }
.tablebody>td {
  padding: 20px;
}
.tablebody>td>img{
  width: 15px;
  height: 15px;
  margin-left: 4px;
}
.tablehead{
  font-size: 28px;
  color: black;
  height: 100px;
}
.tablehead .grade{
  width: 150px;
}

.tablehead .name{
  width: 80px;
}
</style>
